<template>
  <div class="mb-15">
    <v-row class="mb-4">
      <month-pager v-model="yearMonth" />
    </v-row>

    <v-progress-linear
      indeterminate
      color="primary"
      class="my-4"
      v-if="isFetchingPattern || isFetching"
    ></v-progress-linear>

    <div class="mb-4 d-flex align-center">
      <v-btn
        variant="flat"
        color="primary"
        @click="() => (isRegisterDialogOpen = true)"
      >
        {{ $t('workScheduling.registerStaff') }}
      </v-btn>
      <v-spacer />
      <div class="mr-8 d-flex" style="flex-direction: column; align-items: flex-end">
        <div class="mb-2">
          {{ $t('workScheduling.availableSubsidyHours') }}:
          {{ subsidyChildcare ? subsidyChildcare.maxHours.toFixed(1) : "-" }}
        </div>
        <div>
          {{ $t('workScheduling.remainingHours') }}:
          {{
            subsidyChildcare ? subsidyChildcare.remainingHours.toFixed(1) : "-"
          }}
        </div>
      </div>
      <v-btn
        @click="downloadShiftPattern"
        color="primary"
        variant="outlined"
        :disabled="isFetching"
      >
        <v-icon start>mdi-tray-arrow-down</v-icon>
        {{ $t('workScheduling.download') }}
      </v-btn>
    </div>

    <div class="d-flex mb-4">
      <v-checkbox
        v-model="isPatternMode"
        color="primary"
        :label="$t('workScheduling.patternMode')"
        @update:model-value="changePatternMode()"
      ></v-checkbox>
      <v-spacer />
      <v-spacer />
      <v-btn
        @click="openUpdatePlacement"
        color="primary"
        variant="outlined"
        :disabled="isFetching"
      >
        {{ $t('workScheduling.updatePlacement') }}
      </v-btn>
    </div>

    <!-- 連続入力モード　選択　-->
    <div class="PatternMode" v-if="isPatternMode"> 
      <v-btn
        variant="outlined"
        :disabled="isFetching"
        style="border-radius: 20px; margin: 2px;"
        :class="{ 'non-active-delete-button': !this.isActiveDelete, 'active-delete-button': this.isActiveDelete }"
        @click="toggleActiveDelete()"
      >
              {{ $t('workScheduling.delete') }}
      </v-btn>
      <div v-for="item in shiftPatternOptions" :key="item.value">
        <v-btn
              variant="outlined"
              :disabled="isFetching"
              style="border-radius: 20px; margin: 2px;"
              :class="{ 'non-active-button': !item.isActivePattern, 'active-button': item.isActivePattern }"
              @click="toggleActivePttern(item.value)"
            >
              {{item.text}}
        </v-btn>
      </div>
    </div>

    <!-- シフト表 -->
    <div>
      <scrollable-panels>
        <template #left-panel-header>
          <div class="panel-header panel-left">
            <div class="schedule-col name">
              <div class="schedule-header-cell">{{ $t('common.name') }}</div>
              <div class="schedule-header-cell-calc">
                {{ $t('workScheduling.requiredStaffMax') }}
              </div>
              <div class="schedule-header-cell-calc">
                {{ $t('workScheduling.requiredStaffMin') }}
              </div>
            </div>
          </div>
        </template>
        <template #left-panel-body>
          <div class="panel-left" ref="monthlyLeftPanel">
            <div
              class="schedule-row"
              v-for="(schedule, i) in scheduleTableRows"
              :key="`row-${i}`"
            >
              <div class="schedule-col name schedule-body-cell">
                {{ schedule.name }}
              </div>
            </div>
          </div>
        </template>

        <template #center-panel-header>
          <div
            class="panel-header panel-center"
            :style="`width: ${numberOfDates * 50}px; position: sticky; top: 0;`"
          >
            <div
              class="schedule-col date"
              v-for="date in tableDates"
              :key="date.date"
              :style="date.isSunday ? 'color: red;' : date.isSaturday ? 'color: blue;' : ''"
            >
              <div class="schedule-header-cell">
                <div>
                  {{ date.date }}
                </div>
              </div>
              <div class="schedule-header-cell-calc">
                {{ date.summaryMax }}
              </div>
              <div class="schedule-header-cell-calc">
                {{ date.summaryMin }}
              </div>
            </div>
          </div>
        </template>
        <template #center-panel-body>
          <div class="panel-center" v-if="!isPatternMode" ref="monthlyCenterPanel">
            <div
              class="schedule-row"
              v-for="(schedule, i) in scheduleTableRows"
              :key="`row-${i}`"
              :style="{ width: `${numberOfDates * 50}px` }"
            >
              <div
                :class="['schedule-col date']"
                v-for="dailyPattern in schedule.dailyPatterns"
                :key="dailyPattern.date"
              >
                <div
                  v-if="dailyPattern.abbreviation"
                  :class="[
                    'schedule-body-cell date',
                    dailyPattern.abbreviation ? 'active' : '',
                  ]"
                  :style="getStyle(dailyPattern)"
                  @click="openDayDetail(schedule.user, dailyPattern.date)"
                >
                  {{ dailyPattern.abbreviation }}
                </div>
                <div
                  v-else
                  class="schedule-body-cell date add"
                  @click="
                    openAddScheduleModal(schedule.user, dailyPattern.date)
                  "
                >
                  <v-icon size="small" color="#d0d0d0">mdi-plus</v-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="panel-center" v-if="isPatternMode" v-show="!isPatternLoading" ref="monthlyCenterPanel">
            <div
              class="schedule-row"
              v-for="(schedule, i) in scheduleTableRows"
              :key="`row-${i}`"
              :style="{ width: `${numberOfDates * 50}px` }"
            >
              <div
                :class="['schedule-col date']"
                v-for="dailyPattern in schedule.dailyPatterns"
                :key="dailyPattern.date"
              >
                <div
                  v-if="dailyPattern.abbreviation"
                  :class="[
                    'schedule-pattern-body-cell date',
                    dailyPattern.abbreviation ? 'active' : '',
                  ]"
                  :style="getStyle(dailyPattern)"
                  @click="PatternModeUpdate(schedule.user, dailyPattern.date)"
                >
                  {{ dailyPattern.abbreviation }}
                </div>
                <div
                  v-if="!dailyPattern.abbreviation && !isActiveDelete"
                  class="schedule-pattern-body-cell date add"
                  @click="PatternModeAdd(schedule.user, dailyPattern.date)"
                >
                  <v-icon size="small" color="#d0d0d0">mdi-plus</v-icon>
                </div>
                <div
                  v-if="!dailyPattern.abbreviation && isActiveDelete"
                  class="schedule-pattern-body-cell date"
                >
                  <v-icon size="small" color="#d0d0d0">mdi-plus</v-icon>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template #right-panel-header>
          <div class="panel-header panel-right">
            <div class="schedule-col actions">
              <div class="schedule-header-cell"></div>
              <div class="schedule-header-cell-calc schedule-header-cell-calc--actions">
                <div class="schedule-actions-metrics">
                  <div class="schedule-actions-metrics__cell schedule-actions-metrics__cell--header">
                    {{ $t('workScheduling.days') }}
                  </div>
                  <div class="schedule-actions-metrics__cell schedule-actions-metrics__cell--header">
                    {{ $t('workScheduling.totalHours') }}
                  </div>
                  <div class="schedule-actions-metrics__cell schedule-actions-metrics__cell--header">
                    {{ $t('workScheduling.paidLeave') }}
                  </div>
                  <div class="schedule-actions-metrics__btn-slot"></div>
                </div>
              </div>
              <div class="schedule-header-cell-calc"></div>
            </div>
          </div>
        </template>
        <template #right-panel-body>
          <div class="panel-right" ref="monthlyRightPanel">
            <div
              class="schedule-row"
              v-for="(schedule, i) in scheduleTableRows"
              :key="`row-${i}`"
            >
              <div class="schedule-col actions schedule-body-cell schedule-body-cell--actions">
                <div class="schedule-actions-metrics">
                  <div class="schedule-actions-metrics__cell schedule-actions-metrics__cell--value">
                    {{ schedule.totalShiftWorkingDays }}
                  </div>
                  <div class="schedule-actions-metrics__cell schedule-actions-metrics__cell--value">
                    {{ schedule.totalShiftHours }}
                  </div>
                  <div class="schedule-actions-metrics__cell schedule-actions-metrics__cell--value">
                    {{ schedule.totalShiftPaidHolidays }}
                  </div>
                  <div class="schedule-actions-metrics__btn-slot">
                    <v-btn
                      variant="outlined"
                      size="small"
                      color="primary"
                      class="schedule-actions-metrics__bulk-btn"
                      @click="openPatternModal(schedule.user)"
                    >
                      {{ $t('workScheduling.bulkRegister') }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </scrollable-panels>
    </div>

    <!-- スタッフ選択 -->
    <v-dialog max-width="640px" v-model="isRegisterDialogOpen">
      <v-card>
        <div class="pa-8">
          <v-progress-linear
            indeterminate
            color="primary"
            class="my-4"
            v-if="isCopyingMembersFromLastMonth"
          ></v-progress-linear>
          
          <div class="d-flex justify-space-between mb-4">
            <v-checkbox
              :label="$t('workScheduling.selectAllStaff')"
              hide-details="auto"
              density="compact"
              @update:model-value="selectAllStaffs(Boolean($event))"
            />
            </div>
          
          <v-divider />
          
          <div class="staff-select__wrapper">
            <draggable 
              v-model="staffObjects" 
              item-key="userId" 
              handle=".drag-handle"
            >
              <template #item="{ element: staff }">
                <div class="my-4 staff d-flex align-center">
                  <v-icon class="mr-2 drag-handle" size="small"> mdi-drag </v-icon>
                  <v-checkbox
                    :label="`${staff.lastName} ${staff.firstName}`"
                    :model-value="staff.isRegistered"
                    hide-details
                    density="compact"
                    @update:model-value="addRegisterUserId(Boolean($event), staff.userId)"
                  />
                </div>
              </template>
            </draggable>
          </div>
        </div>
        
        <v-card-actions class="justify-center">
          <v-btn variant="flat" color="primary" class="mx-2" @click="updateStaffIds">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
        
        <v-progress-linear
          v-if="isUpdatingStaffs"
          indeterminate
          color="primary"
        ></v-progress-linear>
      </v-card>
    </v-dialog>

    <!-- 一括登録　-->
    <v-dialog max-width="1080px" v-model="isPatternModalOpen">
      <v-card v-if="applyingUser">
        <v-card-title>{{ $t('workScheduling.monthlyStaffScheduleRegister') }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <div class="mb-4">
                <h4>{{ $t('workScheduling.staffName') }}</h4>
                <h3>
                  {{ applyingUser.lastName }} {{ applyingUser.firstName }}
                </h3>
              </div>
              <div class="mb-4">
                <h4>{{ $t('workScheduling.shiftPattern') }}</h4>
                <v-select
                  variant="outlined"
                  :items="shiftPatternOptions"
                  item-title="text"
                  item-value="value"
                  v-model="applyingPatternId"
                ></v-select>
              </div>
            </v-col>

            <v-col>
              <month-date-picker :yearMonth="yearMonth" v-model="applyingDates">
                <template #date="{ date }">
                  <div
                    :class="['month-date-picker-cell']"
                    :style="`background-color: ${
                      getRegisteredSchedule(date)
                        ? getRegisteredSchedule(date)?.color
                        : null
                    }`"
                  >
                    <span v-if="getRegisteredSchedule(date)"
                      :style="`color: ${getRegisteredSchedule(date)?.textcolor}`"
                    >
                      {{ getRegisteredSchedule(date)?.abbreviation }}
                    </span>
                  </div>
                </template>
              </month-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            variant="flat"
            color="primary"
            class="mx-2"
            :disabled="!isApplyButtonValid"
            @click="applyPattern"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
        <v-progress-linear
          indeterminate
          color="primary"
          v-if="isApplying"
        ></v-progress-linear>
      </v-card>
    </v-dialog>

    <!-- シフトパターン編集 -->
    <v-dialog max-width="1080px" v-model="isEditModalOpen">
      <v-card>
        <v-card-title>{{ $t('workScheduling.editShiftPattern') }}</v-card-title>
        <v-card-text v-if="editingPattern && editingUser">
          <v-row class="mb-4">
            <v-col>
              <div class="mb-4">
                <h4>{{ $t('workScheduling.staffName') }}</h4>
                <h3>{{ editingUser.lastName }} {{ editingUser.firstName }}</h3>
              </div>
            </v-col>
            <v-col>
              <div class="mb-4">
                <h4>{{ $t('common.date') }}</h4>
                <h3>{{ formatModalDate(editingDate) }}</h3>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field
                class="mb-4"
                hide-details
                density="compact"
                variant="outlined"
                :label="$t('workScheduling.abbreviation')"
                v-model="editingPattern.abbreviation"
              />
              <div>{{ $t('workScheduling.color') }}</div>
              <div class="mb-4">
                <color-picker v-model="editingPattern.color as string" />
              </div>

              <div>
                <div v-for="(timetable, i) in editingPattern.timetables" :key="i">
                  <v-card
                    v-if="timetable.operationType !== 'remove'"
                    variant="outlined"
                    class="pa-4 my-4"
                  >
                    <v-text-field
                      class="mb-4"
                      variant="outlined"
                      :label="$t('common.name')"
                      v-model="timetable.name"
                      :rules="[required]"
                    />
                    <v-text-field
                      class="mb-4"
                      hide-details
                      density="compact"
                      variant="outlined"
                      :label="$t('workScheduling.abbreviation')"
                      v-model="timetable.abbreviation"
                      :rules="[required, isAbbreviationValid]"
                    />
                    <div>{{ $t('workScheduling.color') }}</div>
                    <div class="mb-4">
                      <color-picker v-model="timetable.color as string" />
                    </div>

                    <h4 class="mb-2">{{ $t('workScheduling.timeSetting') }}</h4>
                    <div class="d-flex align-center mb-4">
                      <hour-minute-input v-model="timetable.startMin" />
                      <div class="px-4">〜</div>
                      <div class="d-flex">
                        <hour-minute-input v-model="timetable.endMin" />
                      </div>
                    </div>

                    <h4 class="mb-2">{{ $t('workScheduling.shiftPatternSettings.form.category') }}</h4>
                    <v-select
                      class="mb-4"
                      :items="descriptions"
                      item-title="title"
                      item-value="value"
                      variant="outlined"
                      density="compact"
                      hide-details
                      v-model="timetable.category"
                      color="primary"
                    ></v-select>

                    <div v-if="timetable.category === 'holiday'">
                      <h4 class="mb-2">{{ $t('workScheduling.holidayReason') }}</h4>
                      <v-text-field
                        class="mb-4"
                        hide-details
                        density="compact"
                        variant="outlined"
                        v-model="timetable.comment"
                        color="primary"
                      />
                    </div>

                    <div v-if="timetable.category === 'workDescription'">
                      <h4 class="mb-2">{{ $t('workScheduling.workDescription') }}</h4>
                      <v-select
                        class="mb-4"
                        :items="workDescriptionOptions"
                        item-title="text"
                        item-value="value"
                        variant="outlined"
                        density="compact"
                        hide-details
                        v-model="timetable.workDescriptionId"
                        color="primary"
                      ></v-select>
                    </div>

                    <div class="d-flex justify-center mt-4">
                      <v-btn
                        variant="flat"
                        color="red"
                        theme="dark"
                        @click="
                          removeTimetableFromEditingPattern(
                            i,
                            timetable.timetableId
                          )
                        "
                      >
                        {{ $t('workScheduling.deleteTimeSlot') }}
                      </v-btn>
                    </div>
                  </v-card>
                </div>
              </div>

              <div class="d-flex justify-center my-4">
                <v-btn
                  variant="flat"
                  color="primary"
                  @click="addTimetableToEditingPattern"
                >
                  {{ $t('workScheduling.addTimeSlot') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            variant="flat"
            color="red"
            theme="dark"
            class="mx-2"
            @click="deleteEditingPattern"
          >
            {{ $t('workScheduling.delete') }}
          </v-btn>
          <v-btn
            variant="flat"
            color="primary"
            class="mx-2"
            @click="saveEditingPattern"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
        <v-progress-linear
          indeterminate
          color="primary"
          v-if="isUpdatingShift"
        ></v-progress-linear>
      </v-card>
    </v-dialog>

    <!-- シフトパターン追加 -->
    <v-dialog max-width="1080px" v-model="isAddScheduleModalOpen">
      <v-card v-if="addingUser && addingDate && !isPatternMode">
        <v-card-title>{{ $t('workScheduling.addShiftPattern') }}</v-card-title>
        <v-card-text>
          <v-row class="mb-4">
            <v-col>
              <div class="mb-4">
                <h4>{{ $t('workScheduling.staffName') }}</h4>
                <h3>{{ addingUser.lastName }} {{ addingUser.firstName }}</h3>
              </div>
            </v-col>
            <v-col>
              <div class="mb-4">
                <h4>{{ $t('common.date') }}</h4>
                <h3>{{ formatModalDate(addingDate) }}</h3>
              </div>
            </v-col>
          </v-row>

          <div class="mb-4">
            <h4>{{ $t('workScheduling.shiftPattern') }}</h4>
            <v-select
              variant="outlined"
              :items="shiftPatternOptions"
              item-title="text"
              item-value="value"
              v-model="addingPatternId"
            ></v-select>
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            variant="flat"
            color="primary"
            class="mx-2"
            :disabled="!addingPatternId"
            @click="addPatternWithUserAndDate"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
        <v-progress-linear
          indeterminate
          color="primary"
          v-if="isApplying"
        ></v-progress-linear>
      </v-card>
    </v-dialog>

    <!-- 配置の再計算 -->
    <v-dialog
      max-width="600px"
      v-model="isUpdatePlacement"
    >
      <v-card style="align-items: center; justify-content: center; height: 180px;">
        <v-card-title style="display: flex; align-items: center; justify-content: center;">
          <v-icon style="color: red">mdi-information-outline</v-icon>&nbsp;
          {{ $t('workScheduling.runPlacementCalc') }}
        </v-card-title>
        <v-card-text style="display: flex; align-items: center; justify-content: center; color: black;">{{ $t('workScheduling.placementCalcNote') }}</v-card-text>
        <div style="display: flex; align-items: center; justify-content: center;">
          <v-card-actions>
            <v-btn
              variant="flat"
              color="primary"
              class="mx-2"
              @click="UpdateExpectedPlacement"
            >
              {{ $t('workScheduling.confirm') }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <!-- ローディング　-->
    <v-overlay
      v-model="isPatternLoading"
      class="align-center justify-center"
      persistent
      z-index="5000"
    >
      <v-card
        height="200"
        width="200"
        class="d-flex align-center justify-center"
        rounded="lg"
        elevation="4"
      >
        <v-progress-circular
          color="primary"
          indeterminate
          :size="150"
        >
          {{ $t('common.processing') }}
        </v-progress-circular>
      </v-card>
    </v-overlay>

  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import draggable from "vuedraggable";
import { monthlyScheduleModule } from "@/store/viewModules/work-schedule/monthlyScheduleModule";
import ApiShift, {
  DayScheduleUpdateRequest,
  DayScheduleUpdateRequestTimetable,
} from "@/api/ApiShift";
import {
  shiftPatternModule,
  WorkDescriptions,
} from "@/store/viewModules/work-schedule/shiftPatternModule";
import ValidationMixin from "@/mixins/ValidationMixin";

import MonthPager from "@/components/atoms/MonthPager.vue";
import MonthDatePicker from "@/components/organisms/work-schedule/MonthDatePicker.vue";
import ScrollablePanels from "@/components/molecules/ScrollablePanels.vue";
import ColorPicker from "@/components/molecules/ColorPicker.vue";
import HourMinuteInput from "@/components/molecules/HourMinuteInput.vue";
import dayjs from "dayjs";
import { NurseryUserResponse } from "chaild-api/src/component/nursery/user/types";
import { workDescriptionModule } from "@/store/viewModules/work-schedule/workDescriptionModule";
import { dailyScheduleModule } from "@/store/viewModules/work-schedule/dailyShceduleModule";
import "dayjs/locale/en";
import LocalDataService from "@/service/LocalDataService";
import {
  formatSchedulePersonName,
} from "@/utils/scheduleNameDisplay";
import { observeSchedulePanelRowHeights } from "@/utils/syncSchedulePanelRowHeights";

dayjs.locale("en");

const hours = [...Array(12)].map((emp, i) => i);
const minutes = [...Array(4)].map((emp, i) => i * 15);

interface DataType {
  isFetching: boolean;
  isUpdatingStaffs: boolean;
  isRegisterDialogOpen: boolean;
  isCopyingMembersFromLastMonth: boolean;
  applyingUser: NurseryUserResponse | null;
  applyingDates: number[];
  applyingPatternId: number | null;
  isApplying: boolean;
  isFetchingPattern: boolean;
  isUpdatingShift: boolean;
  editingUser: NurseryUserResponse | null;
  editingDate: string | null;
  addingUser: NurseryUserResponse | null;
  addingDate: string | null;
  addingPatternId: number | null;
  isUpdatePlacement: boolean;
  tableDates: Array<{ 
    date: string; 
    summaryMax?: string; 
    summaryMin?: string; 
    isSaturday?: boolean;
    isSunday?: boolean;
  }>;
  isPatternMode: boolean;
  isActiveDelete: boolean;
  isPatternLoading: boolean;
  // shiftPatternOptions を追加
  shiftPatternOptions: Array<{ value: number; text: string; abbreviation: string; isActivePattern: boolean }>;
  rowHeightObservers: Array<() => void>;
}

interface StaffRegistrationObject {
  userId: number;
  firstName: string;
  lastName: string;
  isRegistered: boolean;
}

interface ScheduleTableRowItem {
  name: string;
  attendanceCount: number;
  offCount: number;
  dailyPatterns: {
    date: string;
    abbreviation: string | null;
    color: string | null;
  }[];
  user: NurseryUserResponse;
  totalShiftWorkingDays: number;
  totalShiftHours: number;
  totalShiftPaidHolidays: number;
}

export default defineComponent({
  components: {
    draggable,
    MonthPager,
    MonthDatePicker,
    ScrollablePanels,
    ColorPicker,
    HourMinuteInput,
  },
  mixins: [ValidationMixin],
  data: (): DataType => {
    return {
      isFetching: false,
      isUpdatingStaffs: false,
      isRegisterDialogOpen: false,
      isCopyingMembersFromLastMonth: false,
      applyingUser: null,
      applyingDates: [],
      applyingPatternId: null,
      isApplying: false,
      isFetchingPattern: false,
      isUpdatingShift: false,
      editingUser: null,
      editingDate: null,
      addingUser: null,
      addingDate: null,
      addingPatternId: null,
      isUpdatePlacement: false,
      tableDates: [],
      isPatternMode: false,
      isActiveDelete: false,
      isPatternLoading: false,
      shiftPatternOptions: [], // Computed -> dataに移動
      rowHeightObservers: [],
    };
  },
  watch: {
    yearMonth: {
      handler() {
        monthlyScheduleModule.listShiftUsers();
      },
    },
    // ストアの変更を監視して、dataの shiftPatternOptions を1回だけ更新する
    rawShiftPatterns: {
      handler(patterns) {
        this.shiftPatternOptions = patterns.map((pattern: any) => ({
          value: pattern.shiftPatternId,
          text: pattern.name,
          abbreviation: pattern.abbreviation,
          isActivePattern: false,
        }));
      },
      immediate: true,
      deep: true,
    },
    scheduleTableRows: {
      handler() {
        this.setupScheduleRowHeightSync();
      },
      deep: true,
    },
    isPatternMode() {
      this.setupScheduleRowHeightSync();
    },
  },
  computed: {
    // watchで監視するためのヘルパー算出プロパティ
    rawShiftPatterns() {
      return shiftPatternModule.shiftPatterns;
    },
    yearMonth: {
      get(): string {
        return monthlyScheduleModule.yearMonth;
      },
      async set(value: string) {
        await Promise.all([
          this.onYearMonthChange(value)
        ]);
        await Promise.all([
          this.updateTableDates()
        ]);
      },
    },
    monthlySchedules() {
      if (monthlyScheduleModule.monthlySchedule) {
        return monthlyScheduleModule.monthlySchedule.items;
      }
      return [];
    },
    subsidyChildcare() {
      if (monthlyScheduleModule.monthlySchedule) {
        return monthlyScheduleModule.monthlySchedule.subsidyChildcare;
      }
      return undefined;
    },
    summaries() {
      if (monthlyScheduleModule.monthlySchedule) {
        return monthlyScheduleModule.monthlySchedule.summaries;
      }
      return undefined;
    },
    scheduleTableRows(): ScheduleTableRowItem[] {
      return this.monthlySchedules.map((schedule) => {
        const name = formatSchedulePersonName(
          schedule.nurseryUser.lastName,
          schedule.nurseryUser.firstName
        );

        // 修正：元のデータを書き換えないように map でクローンして返す！
        const safeDailyPatterns = schedule.dailyPatterns.map((pattern) => {
          let mappedColor = pattern.color;
          
          if (mappedColor && !mappedColor.includes("&")) {
            const contrastRatio = this.calculateContrastRatio(mappedColor, "#FFFFFF");
            const fontColor = contrastRatio < 3.0 ? "#000000" : "#FFFFFF";
            mappedColor = mappedColor + "&" + fontColor;
          }
          
          return {
            ...pattern,
            color: mappedColor
          };
        });

        return {
          name,
          attendanceCount: 0,
          offCount: 0,
          dailyPatterns: safeDailyPatterns, // ⭕️ クローンした安全な配列を渡す
          user: schedule.nurseryUser,
          totalShiftWorkingDays: schedule.totalShiftWorkingDays,
          totalShiftHours: schedule.totalShiftHours,
          totalShiftPaidHolidays: schedule.totalShiftPaidHolidays,
        };
      });
    },
    numberOfDates(): number {
      const daysInMonth = dayjs(this.yearMonth).daysInMonth();
      return daysInMonth;
    },
    staffOptions() {
      return monthlyScheduleModule.shiftStaffs.map((staff) => {
        return {
          value: staff.userId,
          text: `${staff.lastName} ${staff.firstName}`,
        };
      });
    },
    staffObjects: {
      get(): StaffRegistrationObject[] {
        return monthlyScheduleModule.shiftStaffs.filter((staff) => !staff.isHidden).map((staff) => {
          const isGonnaRegister =
            monthlyScheduleModule.registerStaffIds.indexOf(staff.userId) >= 0;
          const findSchedule = this.monthlySchedules.find(
            (item) => item.nurseryUser.userId === staff.userId
          );
          const hasAlreadyRegistered = findSchedule ? true : false;

          const isGonnaRemove =
            monthlyScheduleModule.removeStaffIds.indexOf(staff.userId) >= 0;

          const isRegistered = isGonnaRemove
            ? false
            : isGonnaRegister || hasAlreadyRegistered;
          return {
            userId: staff.userId,
            firstName: staff.firstName,
            lastName: staff.lastName,
            isRegistered,
          };
        });
      },
      async set(value: StaffRegistrationObject[]) {
        const shiftUserIds = value.map((item) => item.userId);
        monthlyScheduleModule.setSortStaffIds(shiftUserIds);

        this.isUpdatingStaffs = true;
        await monthlyScheduleModule.sortShiftUsers();
        this.isUpdatingStaffs = false;

        this.isFetching = true;
        await monthlyScheduleModule.listMonthlySchedule();
        this.isFetching = false;
      },
    },
    registerUserIds() {
      return monthlyScheduleModule.registerStaffIds;
    },
    removeUserIds() {
      return monthlyScheduleModule.removeStaffIds;
    },
    isApplyButtonValid() {
      if (this.applyingPatternId) {
        return true;
      }
      return false;
    },
    isPatternModalOpen: {
      get() {
        return !!this.applyingUser;
      },
      set(value: boolean) {
        if (!value) {
          this.applyingUser = null;
          this.applyingPatternId = null;
          this.applyingDates = [];
        }
      },
    },
    editingPattern(): DayScheduleUpdateRequest | null {
      return monthlyScheduleModule.editingShiftPattern;
    },
    isEditModalOpen: {
      get() {
        if (this.editingPattern) {
          return true;
        }
        return false;
      },
      set(value: boolean) {
        if (!value) {
          this.editingUser = null;
          monthlyScheduleModule.setShiftPattern(null);
        }
      },
    },
    isAddScheduleModalOpen: {
      get() {
        if (this.addingUser && this.addingDate) {
          return true;
        }
        return false;
      },
      set(value: boolean) {
        if (!value) {
          this.addingUser = null;
          this.addingDate = null;
        }
      },
    },
    workDescriptions() {
      return workDescriptionModule.workDescriptions;
    },
    workDescriptionOptions(): Record<string, any>[] {
      return [
        ...this.workDescriptions.map((wd) => ({
          text: wd.name,
          value: wd.workDescriptionId,
        })),
      ];
    },
    descriptions(): Record<string, any>[] {
      return Object.keys(WorkDescriptions).map((key) => ({
        title: this.$t(WorkDescriptions[key]) as string,
        value: key,
      }));
    },
  },
  methods: {
    teardownRowHeightObservers() {
      this.rowHeightObservers.forEach((disconnect) => disconnect());
      this.rowHeightObservers = [];
    },
    setupScheduleRowHeightSync() {
      this.teardownRowHeightObservers();
      this.$nextTick(() => {
        const leftPanel = this.$refs.monthlyLeftPanel;
        const centerPanel = this.$refs.monthlyCenterPanel;
        const rightPanel = this.$refs.monthlyRightPanel;
        if (leftPanel instanceof Element && centerPanel instanceof Element && rightPanel instanceof Element) {
          this.rowHeightObservers.push(
            observeSchedulePanelRowHeights(leftPanel, centerPanel, rightPanel, 44)
          );
        }
      });
    },
    formatModalDate(isoDate: string | null): string {
      if (!isoDate) {
        return "";
      }
      const d = dayjs(isoDate);
      return d.isValid() ? d.format("DD-MM-YYYY") : isoDate;
    },
    async onYearMonthChange(value: string) {
      this.isFetching = true;
      await monthlyScheduleModule.onYearMonthChange(value);
      this.isFetching = false;
    },
    addRegisterUserId(value: boolean, userId: number) {
      if (value) {
        const findSchedule = this.monthlySchedules.find(
          (item) => item.nurseryUser.userId === userId
        );
        if (findSchedule) {
          monthlyScheduleModule.removeRemoveStaffId(userId);
        } else {
          monthlyScheduleModule.addRegisterStaffIds([userId]);
        }
      } else {
        const findSchedule = this.monthlySchedules.find(
          (item) => item.nurseryUser.userId === userId
        );
        if (findSchedule) {
          monthlyScheduleModule.addRemoveStaffIds([userId]);
        } else {
          monthlyScheduleModule.removeRegisterStaffId(userId);
        }
      }
    },
    changePatternMode() {
      this.shiftPatternOptions.forEach((item) => {
          item.isActivePattern = false
      });
      this.addingPatternId = null
      this.isActiveDelete = false
    },
    toggleActivePttern(value: number) {
      this.isActiveDelete =false;
      this.shiftPatternOptions.forEach((item) => {
          item.isActivePattern = false
      });
      const activePattern = this.shiftPatternOptions.find((item) => item.value === value)
      if (activePattern) {
        activePattern.isActivePattern = !activePattern.isActivePattern
        this.addingPatternId = activePattern.value
      }
      this.isPatternMode = !this.isPatternMode
      this.isPatternMode = !this.isPatternMode
    },
    toggleActiveDelete() {
      this.shiftPatternOptions.forEach((item) => {
          item.isActivePattern = false
      });
      this.isActiveDelete = !this.isActiveDelete
    },
    selectAllStaffs(value: boolean) {
      if (value) {
        const unregistereds = this.staffObjects
          .filter((so) => {
            const findSchedule = this.monthlySchedules.find(
              (item) => item.nurseryUser.userId === so.userId
            );
            if (findSchedule) {
              return false;
            }
            return true;
          })
          .map((so) => so.userId);

        const gonnaRemoves = [...this.removeUserIds];

        const targets = [...unregistereds, ...gonnaRemoves];

        targets.forEach((id) => {
          this.addRegisterUserId(true, id);
        });
      } else {
        const alreadyRegistereds = this.staffObjects
          .filter((so) => {
            const findSchedule = this.monthlySchedules.find(
              (item) => item.nurseryUser.userId === so.userId
            );
            if (findSchedule) {
              return true;
            }
            return false;
          })
          .map((so) => so.userId);

        const gonnaRegisters = [...this.registerUserIds];
        const registereds = [...alreadyRegistereds, ...gonnaRegisters];
        registereds.forEach((id) => {
          this.addRegisterUserId(false, id);
        });
      }
    },
    openPatternModal(user: NurseryUserResponse) {
      this.applyingUser = user;
    },
    async updateStaffIds() {
      this.isUpdatingStaffs = true;
      await monthlyScheduleModule.registerStaffs();
      await monthlyScheduleModule.removeStaffs();
      this.isUpdatingStaffs = false;
      this.isRegisterDialogOpen = false;
    },
    async applyPattern() {
      if (this.applyingPatternId && this.applyingUser) {
        this.isApplying = true;
        await monthlyScheduleModule.applyPattern({
          shiftPatternId: this.applyingPatternId,
          userId: this.applyingUser.userId,
          days: this.applyingDates,
        });
        this.isApplying = false;
        this.applyingPatternId = null;
        this.applyingDates = [];
      }
    },
    async openDayDetail(user: NurseryUserResponse, date: string) {
      this.isFetchingPattern = true;
      this.editingUser = user;
      this.editingDate = date;

      const dateInt = dayjs(date).date();

      await monthlyScheduleModule.getUserShiftPattern({
        userId: user.userId,
        day: dateInt,
      });
      this.isFetchingPattern = false;
    },
    openAddScheduleModal(user: NurseryUserResponse, date: string) {
      this.addingUser = user;
      this.addingDate = date;
    },
    async PatternModeAdd(user: NurseryUserResponse, date: string) {
      this.addingUser = user;
      this.addingDate = date;
      if (this.addingUser && this.addingDate && this.addingPatternId) {
        this.isPatternLoading = true;
        const dateInt = dayjs(this.addingDate).date();
        await monthlyScheduleModule.applyPattern({
          shiftPatternId: this.addingPatternId,
          userId: this.addingUser.userId,
          days: [dateInt],
        });
        monthlyScheduleModule.listMonthlySchedule();
        this.isPatternLoading = false;
        this.addingUser = null;
        this.addingDate = null;
      }
    },
    async PatternModeUpdate(user: NurseryUserResponse, date: string) {
      this.editingUser = user;
      this.editingDate = date;
      this.addingUser = user;
      this.addingDate = date;
      if (this.isActiveDelete && this.editingUser && this.editingDate) {
        const dateInt = dayjs(this.editingDate).date();
        this.isPatternLoading = true;
        await monthlyScheduleModule.deleteShiftPatternByDate({
          userId: this.editingUser.userId,
          date: dateInt,
        });
        await monthlyScheduleModule.listMonthlySchedule();
        await monthlyScheduleModule.updateEditingPattern(null);
        this.isPatternLoading = false;
        this.editingUser = null;
        this.editingDate = null;
        this.addingUser = null;
        this.addingDate = null;
      } else if (!this.isActiveDelete && this.addingPatternId && this.editingUser && this.editingDate) {
        const dateInt = dayjs(this.editingDate).date();
        this.isPatternLoading = true;
        await monthlyScheduleModule.deleteShiftPatternByDate({
          userId: this.editingUser.userId,
          date: dateInt,
        });
        await monthlyScheduleModule.listMonthlySchedule();
        this.isUpdatingShift = false;

        await monthlyScheduleModule.updateEditingPattern(null);

        this.isApplying = true;
        await monthlyScheduleModule.applyPattern({
          shiftPatternId: this.addingPatternId,
          userId: this.editingUser.userId,
          days: [dateInt],
        });
        monthlyScheduleModule.listMonthlySchedule();
        this.isPatternLoading = false;
        this.editingUser = null;
        this.editingDate = null;
        this.addingUser = null;
        this.addingDate = null;
      }

    },
    removeTimetableFromEditingPattern(index: number, timetableId?: number) {
      if (monthlyScheduleModule.editingShiftPattern) {
        const newPattern = { ...monthlyScheduleModule.editingShiftPattern };
        if (timetableId) {
          newPattern.timetables = newPattern.timetables?.map((tt) => {
            if (tt.timetableId === timetableId) {
              tt.operationType = "remove";
            }
            return tt;
          });
        } else {
          newPattern.timetables = newPattern.timetables.splice(index, 1);
        }
        monthlyScheduleModule.updateEditingPattern(newPattern);
      }
    },
    addTimetableToEditingPattern() {
      if (monthlyScheduleModule.editingShiftPattern) {
        const newPattern = { ...monthlyScheduleModule.editingShiftPattern };
        const newTimetable: DayScheduleUpdateRequestTimetable = {
          operationType: "add",
          name: "",
          abbreviation: "",
          color: "#029ec0",
          startMin: 0,
          endMin: 0,
          comment: "",
          category: "workDescription",
        };

        if (newPattern.timetables) {
          newPattern.timetables.push(newTimetable);
        } else {
          newPattern.timetables = [newTimetable];
        }
        monthlyScheduleModule.updateEditingPattern(newPattern);
      }
    },
    async saveEditingPattern() {
      if (this.editingUser && this.editingDate) {
        const dateInt = dayjs(this.editingDate).date();
        this.isUpdatingShift = true;
        await monthlyScheduleModule.saveEditingPattern({
          userId: this.editingUser.userId,
          date: dateInt,
        });
        monthlyScheduleModule.listMonthlySchedule();
        this.isUpdatingShift = false;

        monthlyScheduleModule.updateEditingPattern(null);
        this.editingUser = null;
        this.editingDate = null;
      }
    },
    async deleteEditingPattern() {
      if (this.editingUser && this.editingDate) {
        const dateInt = dayjs(this.editingDate).date();
        this.isUpdatingShift = true;
        await monthlyScheduleModule.deleteShiftPatternByDate({
          userId: this.editingUser.userId,
          date: dateInt,
        });
        monthlyScheduleModule.listMonthlySchedule();
        this.isUpdatingShift = false;

        monthlyScheduleModule.updateEditingPattern(null);
        this.editingUser = null;
        this.editingDate = null;
      }
    },
    async addPatternWithUserAndDate() {
      if (this.addingUser && this.addingDate && this.addingPatternId) {
        this.isApplying = true;
        const dateInt = dayjs(this.addingDate).date();
        await monthlyScheduleModule.applyPattern({
          shiftPatternId: this.addingPatternId,
          userId: this.addingUser.userId,
          days: [dateInt],
        });
        await new Promise((resolve) => setTimeout(resolve, 3000));
        monthlyScheduleModule.listMonthlySchedule();
        this.isApplying = false;
        this.addingUser = null;
        this.addingDate = null;
        this.addingPatternId = null;
      }
    },
    async copyMembersFromLastMonth() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        this.isCopyingMembersFromLastMonth = true;

        const yearInt = dayjs(this.yearMonth).year();
        const monthInt = dayjs(this.yearMonth).month() - 1;

        const response = await ApiShift.listMonthlySchedule({
          nurseryId,
          year: yearInt,
          month: monthInt,
        });

        if (response) {
          const lastMonthMemberIds = response.items.map(
            (item) => item.nurseryUser.userId
          );
          const notRegistereds = lastMonthMemberIds.filter((userId) => {
            const findFromCurrent = this.monthlySchedules.find(
              (schedule) => schedule.nurseryUser.userId === userId
            );
            if (findFromCurrent) {
              return false;
            }
            return true;
          });

          notRegistereds.forEach((userId) => {
            this.addRegisterUserId(true, userId);
          });
        }

        this.isCopyingMembersFromLastMonth = false;
      }
    },
    getRegisteredSchedule(date: number) {
      if (this.applyingUser) {
        const findSchedules = this.monthlySchedules.find(
          (ms) => ms.nurseryUser.userId === this.applyingUser!.userId
        );
        if (findSchedules) {
          const targetDate = dayjs(`${this.yearMonth}-${date}`).format(
            "YYYY-MM-DD"
          );
          const dateSchedule = findSchedules.dailyPatterns.find(
            (dp) => dp.date === targetDate
          );
          if (dateSchedule) {
            const raw = dateSchedule.color;
            if (raw && raw.includes('&')) {
              const parts = raw.split('&');
              if (parts.length >= 2) {
                return {
                  ...dateSchedule,
                  color: parts[0],
                  textcolor: parts[1],
                };
              }
            }
            const bgHex =
              raw && /^#[0-9A-Fa-f]{6}$/.test(raw) ? raw : null;
            let textcolor = '#000000';
            if (bgHex) {
              textcolor =
                this.calculateRelativeLuminance(bgHex) > 0.5
                  ? '#000000'
                  : '#ffffff';
            } else if (raw) {
              textcolor = '#ffffff';
            }
            return {
              ...dateSchedule,
              textcolor,
            };
          }
        }
      }

      return null;
    },
    calculateRelativeLuminance(hexColor: string): number {
      const r = parseInt(hexColor.slice(1, 3), 16) / 255;
      const g = parseInt(hexColor.slice(3, 5), 16) / 255;
      const b = parseInt(hexColor.slice(5, 7), 16) / 255;

      const luminance = (channel: number) => {
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
      };

      return 0.2126 * luminance(r) + 0.7152 * luminance(g) + 0.0722 * luminance(b);
    },
    calculateContrastRatio(color1: string, color2: string): number {
      const luminance1 = this.calculateRelativeLuminance(color1);
      const luminance2 = this.calculateRelativeLuminance(color2);
      const lighter = Math.max(luminance1, luminance2);
      const darker = Math.min(luminance1, luminance2);
      return (lighter + 0.05) / (darker + 0.05);
    },
    getStyle(dailyPattern: any) {
    let backgroundColor = dailyPattern.color;
    let fontColor = "white";

    if (backgroundColor && backgroundColor.includes('&')) {
      const colors = backgroundColor.split('&');
      backgroundColor = colors[0];
      fontColor = colors[1];
    }

    return `background-color: ${backgroundColor}; color: ${fontColor};`;
  },
    async downloadShiftPattern() {
      this.isFetching = true;
      const response = await monthlyScheduleModule.dlShiftPattern();
      if (response) {
        alert(this.$t('workScheduling.downloadStarted') as string);
      }
      this.isFetching = false;
    },
    openUpdatePlacement() {
      this.isUpdatePlacement = true;
    },
    async UpdateExpectedPlacement() {
      this.isFetching = true;
      this.isUpdatePlacement = false;
      await new Promise((resolve) => setTimeout(resolve, 20000));
      await dailyScheduleModule.UpdateMonthlyExpectedPlacement(this.yearMonth + '-01');
      await new Promise((resolve) => setTimeout(resolve, 100000));
      console.log("計算完了");
      await Promise.all([
        monthlyScheduleModule.listMonthlySchedule(),
        monthlyScheduleModule.listShiftUsers(),
        shiftPatternModule.listShiftPatterns(),
        workDescriptionModule.listWorkDescriptions(),
      ]);
      await Promise.all([
        this.updateTableDates(),
      ]);
      this.isFetching = false;
    },
    async updateTableDates() {
      const daysInMonth = dayjs(this.yearMonth).daysInMonth();
      const startOfMonth = dayjs(this.yearMonth).startOf("month");
      this.tableDates = [...Array(daysInMonth)].map((_, i) => {
        const dateObj = dayjs(startOfMonth).add(i, "day");
        const dateLabel = dateObj.locale("en").format("DD/MM (ddd)");
        const dateToFindSummary = dateObj.format("YYYY-MM-DD");

        const summary = this.getSummaries()?.find(
          (s) => s.date === dateToFindSummary
        ) as {
          date: string;
          overall: {
            maxGovExpected: number | null;
            minGovExpected: number | null;
          };
        };

        return {
          date: dateLabel,
          summaryMax:
            summary && summary.overall.maxGovExpected
              ? String(summary.overall.maxGovExpected)
              : "-",
          summaryMin:
            summary && summary.overall.minGovExpected
              ? String(summary.overall.minGovExpected)
              : "-",
          isSaturday: dateObj.day() === 6,
          isSunday: dateObj.day() === 0,
        };
      });
    },
    getSummaries() {
      if (monthlyScheduleModule.monthlySchedule) {
        return monthlyScheduleModule.monthlySchedule.summaries;
      }
      return undefined;
    },
  },
  async mounted() {
    this.isFetching = true;
    await Promise.all([
      monthlyScheduleModule.listMonthlySchedule(),
      monthlyScheduleModule.listShiftUsers(),
      shiftPatternModule.listShiftPatterns(),
      workDescriptionModule.listWorkDescriptions(),
    ]);
    await Promise.all([
      this.updateTableDates(),
    ]);
    this.isFetching = false;
    this.setupScheduleRowHeightSync();
  },
  beforeUnmount() {
    this.teardownRowHeightObservers();
  },
});
</script>
<style lang="scss" scoped>
/* スタイル部分は変更なしのため割愛しますが、そのまま使えます */
.staff-select__wrapper {
  max-height: 50vh;
  overflow-y: scroll;
}
.drag-handle {
  margin-top: 7px;
  vertical-align: middle;
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
.panel-header {
  display: flex;
  border-bottom: solid 2px #e0e0e0;
}
.panel-left {
  border-right: solid 2px #e0e0e0;
}
.panel-right {
  border-left: solid 2px #e0e0e0;
}
.schedule-col {
  border-right: solid 1px #f0f0f0;
  &.name { width: 180px; }
  &.count { width: 50px; }
  &.date { width: 50px; display: flex; flex-direction: column; }
  /* Metrics columns + Bulk Register column — avoids clipped buttons */
  &.actions {
    flex: 0 0 auto;
    width: 292px;
    box-sizing: border-box;
    padding-left: 6px;
    padding-right: 8px;
  }
}
.schedule-actions-metrics {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.schedule-actions-metrics__cell {
  flex: 0 0 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  line-height: 1.25;
  padding: 2px 4px;
  word-break: break-word;
}
.schedule-actions-metrics__cell--header {
  font-size: 12px;
  font-weight: bold;
}
.schedule-actions-metrics__cell--value {
  font-size: 14px;
}
.schedule-actions-metrics__btn-slot {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 108px;
  padding-left: 6px;
}
.schedule-actions-metrics__bulk-btn {
  max-width: 100%;
  white-space: nowrap;
  font-size: 0.65rem;
  flex-shrink: 0;
}
.schedule-actions-metrics__bulk-btn :deep(.v-btn__content) {
  font-size: 0.65rem;
  line-height: 1.25;
}
.schedule-header-cell-calc--actions {
  padding-left: 4px;
  padding-right: 4px;
  justify-content: flex-start;
  width: 100%;
  box-sizing: border-box;
}
.schedule-body-cell--actions {
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
  align-items: center;
}
.schedule-header-cell {
  padding: 8px; font-weight: bold; text-align: center; font-size: 12px; height: 50px;
}
.schedule-header-cell-calc {
  padding: 4px; font-weight: bold; text-align: center; font-size: 12px; height: 35px; display: flex; align-items: center; justify-content: center;
}
.schedule-row {
  display: flex;
  align-items: stretch;
  box-sizing: border-box;
  min-height: 44px;
  height: auto;
  border-bottom: solid 1px #f0f0f0;
  background-color: white;
}
.schedule-body-cell {
  font-size: 14px; text-align: center; padding: 8px 0;
  &.name {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    line-height: 1.25;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    box-sizing: border-box;
    min-height: 44px;
  }
  &.date.active {
    cursor: pointer;
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover { transition-property: all; transition-duration: 0.2s; opacity: 0.6; }
  }
  &.date.add {
    cursor: pointer;
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover { transition-property: all; transition-duration: 0.2s; background-color: #f0f0f0; }
  }
}
.schedule-pattern-body-cell {
  font-size: 14px; text-align: center; padding: 8px 0;
  &.date.active {
    cursor: pointer;
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover { transition-property: all; transition-duration: 0.2s; opacity: 0.2; }
  }
  &.date.add {
    cursor: pointer;
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover { transition-property: all; transition-duration: 0.2s; background-color: #ffcbcb; }
  }
  &.date {
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.PatternMode {
  display: flex; margin: 16px; flex-wrap: wrap; padding: 10px; max-width: 100%; overflow-y: auto; height: 130px;
}
.active-button { background-color: #2196F3; color:#FFFFFF; }
.non-active-button { color:#2196F3; }
.active-delete-button { background-color: #f34121; color:#FFFFFF; }
.non-active-delete-button { color:#f34121; }
.month-date-picker-cell {
  height: 30px; width: 100%; display: flex; justify-content: center; align-items: center; color: white;
}
</style>